import Service from "../../services";

const resultModule = {
  namespaced: true,
  state: {
    list: [],
    filter: [],
    result: [],
    remarks: [],
  },
  mutations: {
    FILTER_RESULT: (state, data) => {
      state.filter = data;
    },
    SET_ALL: (state, data) => {
      state.list = data;
    },
    SET_RESULT: (state, data) => {
      state.result = data;
    },
    SET_REMARKS: (state, data) => (state.remarks = data),
  },
  actions: {
    fixTestIssue({ commit }, ln) {
      return Service.result.fixTestIssue(ln);
    },
    filterData(context, payload) {
      Service.result.filterResult(payload).then((res) => {
        context.commit("FILTER_RESULT", res);
      });
    },
    setAll({ commit }) {
      return Service.result.getAllResults().then((res) => {
        commit("SET_ALL", res);
      });
    },
    setResult({ commit }, id) {
      return Service.result
        .getResultDB(id)
        .then((res) => commit("SET_RESULT", res));
    },
    async deleteResult({ commit }, data) {
      let confirmPassword = await Service.auth.confirmPassword(data);

      if (confirmPassword.confirm_password) {
        let token = confirmPassword.token;
        return await Service.result.deleteResult(data.id, token);
      } else {
        throw { message: "password incorrect" };
      }
    },
    async editResult({ commit }, payload) {
      try {
        await Service.result.editResult(payload);
        return true;
      } catch (e) {
        return false;
      }
    },
    printSummary({ commit }) {
      return Service.result.printSummary();
    },
    setRemarks({ commit }) {
      Service.result.getRemarks().then((res) => commit("SET_REMARKS", res));
    },
    deleteFileUpload({ commit }, id) {
      return Service.result.deleteFileUpload(id);
    },
    getLastResultOfAnimal({ commit }, { animalId, testId, isSubTest }) {
      return Service.result.getLastResultOfAnimal(animalId, testId, isSubTest);
    },
    multiprint({ commit }, payload) {
      return Service.result.multiprint(payload);
    },
  },
  getters: {
    getAll(state) {
      return state.list;
    },
    getResult(state) {
      return state.result;
    },
    getDataFromFilter(state) {
      return state.filter;
    },
    getRemarks: (state) => state.remarks,
  },
};
export default resultModule;
